import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import {createUseStyles} from "react-jss";

const availableIconNames = [
  // social icons
  'facebook-square',
  'google-square',
  'linkedin-square',
  'twitter-square',

  // font awesome 5
  'fa-bullhorn',
  'fa-exclamation-triangle',
  'fa-calendar-plus',
  'fa-caret-down',
  'fa-caret-up',
  'fa-check',
  'fa-chevron-left',
  'fa-chevron-right',
  'fa-copy-light',
  'fa-download',
  'fa-eye-slash',
  'fa-filter',
  'fa-info',
  'fa-times',
  'fa-user-plus',
];

const availableIcons = {};
availableIconNames.forEach((icon) => {
  availableIcons[icon] = require(`svg-inline-loader!~/assets/icons/${icon}.svg`)
});

const UIIcon = React.memo(React.forwardRef(({name, className, ...props}, ref) => {
  const classes = useStyles();

  return (
    <div
      ref={ref}
      className={cn(classes.root, className)}
      dangerouslySetInnerHTML={{
        __html: availableIcons[name]
      }}
      {...props}
    />
  )
}));

UIIcon.propTypes = {
  name: PropTypes.string.isRequired
};


const useStyles = createUseStyles({
  root: {
    '-webkit-font-smoothing': 'antialiased',
    width: 14,
    height: 14,

    '& > svg': {
      display: 'block',
      width: '100%',
      height: '100%',
    }
  },
});

export default UIIcon;
